import { Expense, CATEGORY_LABELS } from '../types/expense';

export function exportExpensesToCSV(expenses: Expense[], income: number, year: number = new Date().getFullYear()) {
  // CSV Headers
  const headers = ['Date', 'Category', 'Description', 'Amount', 'Business Purpose', 'Receipt'];
  
  // CSV Rows
  const rows = expenses.map(exp => [
    exp.date,
    CATEGORY_LABELS[exp.category],
    `"${exp.description.replace(/"/g, '""')}"`, // Escape quotes
    exp.amount.toFixed(2),
    `"${(exp.businessPurpose || '').replace(/"/g, '""')}"`,
    exp.receiptUrl ? 'Yes' : 'No'
  ]);
  
  // Add summary rows
  const totalExpenses = expenses.reduce((sum, exp) => sum + exp.amount, 0);
  rows.push([]);
  rows.push(['SUMMARY', '', '', '', '', '']);
  rows.push(['Total 1099 Income', '', '', income.toFixed(2), '', '']);
  rows.push(['Total Expenses', '', '', totalExpenses.toFixed(2), '', '']);
  rows.push(['Expense Ratio', '', '', `${((totalExpenses / income) * 100).toFixed(1)}%`, '', '']);
  
  // Convert to CSV string
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');
  
  // Create download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `1099-Expenses-${year}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function exportScheduleCToCSV(expensesByCategory: Record<string, number>, year: number = new Date().getFullYear()) {
  // Schedule C Line Items
  const scheduleCData = [
    ['Line Number', 'Description', 'Amount'],
    ['8', 'Advertising', expensesByCategory['advertising'] || 0],
    ['9', 'Car and truck expenses', expensesByCategory['vehicle'] || 0],
    ['10', 'Commissions and fees', expensesByCategory['commissions'] || 0],
    ['11', 'Contract labor', expensesByCategory['contract-labor'] || 0],
    ['13', 'Depreciation', expensesByCategory['depreciation'] || 0],
    ['15', 'Insurance (other than health)', expensesByCategory['insurance'] || 0],
    ['16b', 'Other interest', expensesByCategory['interest'] || 0],
    ['17', 'Legal and professional services', expensesByCategory['legal-professional'] || 0],
    ['18', 'Office expense', expensesByCategory['office-expense'] || 0],
    ['20b', 'Rent or lease (other)', expensesByCategory['rent-lease'] || 0],
    ['21', 'Repairs and maintenance', expensesByCategory['repairs-maintenance'] || 0],
    ['22', 'Supplies', expensesByCategory['supplies'] || 0],
    ['23', 'Taxes and licenses', expensesByCategory['taxes-licenses'] || 0],
    ['24a', 'Travel', expensesByCategory['travel'] || 0],
    ['24b', 'Meals (50% deductible)', (expensesByCategory['meals'] || 0) * 0.5],
    ['25', 'Utilities', expensesByCategory['utilities'] || 0],
    ['30', 'Home office deduction', expensesByCategory['home-office'] || 0],
    ['27b', 'Other expenses', expensesByCategory['other'] || 0]
  ];
  
  const csvContent = scheduleCData.map(row => {
    if (typeof row[2] === 'number') {
      return `${row[0]},${row[1]},${row[2].toFixed(2)}`;
    }
    return row.join(',');
  }).join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `Schedule-C-${year}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
